import { apiFetch } from '../apiFetch';



interface SystemEmailParams {
    to: string;
    subject: string;
    headline: string;
    content: string;
    ctaText?: string;
    ctaUrl?: string;
}

/** Onboarding till en ansvarig som godkänts: servern bygger mejlet från kontot. */
export const sendTeacherOnboardingEmail = (userId: string) =>
    sendSystemEmail({ template: 'teacher-onboarding', userId });

export const sendSystemEmail = async (params: SystemEmailParams | { template: 'teacher-onboarding'; userId: string }) => {
    try {
        const response = await apiFetch('/api/email/send-system-email', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(params)
        });

        if (!response.ok) {
            const err = await response.json();
            console.warn("Email sending failed (non-critical):", err);
            // We don't throw here to avoid blocking the UI flow if email fails
            return false;
        }
        return true;
    } catch (e) {
        console.warn("Email network error:", e);
        return false;
    }
};

interface WelcomeEmailParams {
    to: string;
    name: string;
}

// Fast, oredigerbart innehåll server-side — denna endpoint är medvetet
// nåbar utan inloggning (nya konton har ingen session förrän efter detta
// steg i registreringsflödet), så klienten skickar aldrig fritt ämne/text.
export const sendWelcomeEmail = async (params: WelcomeEmailParams) => {
    try {
        const response = await fetch('/api/email/send-welcome-email', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(params)
        });

        if (!response.ok) {
            console.warn("Welcome email failed (non-critical)");
            return false;
        }
        return true;
    } catch (e) {
        console.warn("Welcome email network error:", e);
        return false;
    }
};

/**
 * Skickar en redan skapad faktura. Servern läser allt innehåll (nummer,
 * belopp, mottagare) från databasen och sätter status till SENT.
 */
export const sendInvoiceEmail = async (invoiceId: string) => {
    const response = await apiFetch('/api/email/send-invoice', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ invoiceId })
    });

    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || "Misslyckades att skicka faktura");
    }
    return true;
};
